import { useState, useEffect } from "react";
import BASE_URL from "../../BASEURL";

export default function OurJourneyCMS() {
  const [steps, setSteps] = useState([]);

  useEffect(() => {
    const fetchJourney = async () => {
      try {
        const res = await fetch(`${BASE_URL}/api/journey`);
        if (!res.ok) return;
        const json = await res.json();
        // Expecting: { data: [ { year, title, desc }, ... ] }
        setSteps(Array.isArray(json.data) ? json.data : []);
      } catch (err) {
        console.error('Failed to fetch journey data:', err);
      }
    };
    fetchJourney();
  }, []);

  const handleChange = (index, field, value) => {
    const updated = [...steps];
    updated[index][field] = value;
    setSteps(updated);
  };

  const addStep = () => {
    setSteps([...steps, { year: "", title: "", desc: "" }]);
  };

  const removeStep = (index) => {
    const updated = steps.filter((_, i) => i !== index);
    setSteps(updated);
  };

  // 🔥 Per-step save
  const saveStep = async (index) => {
    const step = steps[index];
    try {
      let res;
      if (step._id) {
        // Update existing
        res = await fetch(`${BASE_URL}/api/journey/${step._id}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ year: step.year, title: step.title, desc: step.desc }),
        });
      } else {
        // Add new
        res = await fetch(`${BASE_URL}/api/journey`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ year: step.year, title: step.title, desc: step.desc }),
        });
      }
      if (!res.ok) {
        const txt = await res.text();
        throw new Error(txt || 'Save failed');
      }
      // Optionally refresh or update _id in state
      const data = await res.json();
      if (data && data._id) {
        setSteps(prev => prev.map((s, i) => i === index ? { ...step, _id: data._id } : s));
      }
      alert(`Step ${index + 1} saved!`);
    } catch (err) {
      alert('Failed to save step');
    }
  };

  return (
    <div className="max-w-5xl mx-auto p-1">
      <h1 className="text-2xl font-bold mb-6">Our Journey CMS</h1>

      {steps.map((step, index) => (
        <div key={index} className="border p-4 rounded mb-4 space-y-3">

          <div className="flex flex-col md:flex-row gap-4">
            <input
              type="text"
              placeholder="Year"
              value={step.year}
              onChange={(e) => handleChange(index, "year", e.target.value)}
              className="border p-2 rounded w-full"
            />

          </div>
            <input
              type="text"
              placeholder="Title"
              value={step.title}
              onChange={(e) => handleChange(index, "title", e.target.value)}
              className="border p-2 rounded flex-1 w-full"
            />

          <textarea
            placeholder="Description"
            value={step.desc}
            onChange={(e) => handleChange(index, "desc", e.target.value)}
            className="border p-2 rounded w-full"
          />

          {/* ACTION BUTTONS */}
          <div className="flex gap-4 pt-2">
            <button
              onClick={() => saveStep(index)}
              className="bg-primary text-white px-4 py-1 rounded"
            >
              Save
            </button>

            <button
              onClick={() => removeStep(index)}
              className="bg-red-500 text-white px-4 py-1 rounded"
            >
              Delete
            </button>
          </div>

        </div>
      ))}

      <div className="flex gap-4 mt-6">
        <button
          onClick={addStep}
          className="bg-green-600 text-white px-4 py-2 rounded"
        >
          + Add Step
        </button>
      </div>
    </div>
  );
}